const initialState = {};

function app(state = initialState, action) {
  return state;
}

export default app;